import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import { getNavigationConfig } from "./navigationConfig";

const HeaderProvider = ({ children, logoPath }) => {
  const location = useLocation();

  // Pages sans header
  const excludedPaths = ["/", "/login", "/inscription"];
  const isExcludedPath = excludedPaths.some(
    (path) => location.pathname === path || location.pathname.startsWith(path + "/")
  );

  if (isExcludedPath) return children;

  // 🔍 Debug pour vérifier la configuration reçue
  const config = getNavigationConfig(location.pathname);
  console.log("📍 PAGE:", location.pathname);
  console.log("📦 CONFIG:", config);

  const { primary, secondary } = config;
  const showSecondary = secondary && secondary.length > 0;

  return (
    <div className="page-with-header">
      <Header
        logo={logoPath || "/img/1200px-logo-icam---2008-1@2x.png"}
        primaryItems={primary}
        secondaryItems={secondary}
        showSecondary={showSecondary}
      />
      <main className="main-content">{children}</main>
    </div>
  );
};

export default HeaderProvider;
